import React, { useContext } from 'react';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';
import { Body, FlexColumn } from '@ubeya/shared-web/components';
import { Container, TabTitle } from './styled';
import { ClientDetails, Settings, BankDetails, Tax, TimeSheets } from './sections';

export const InvoicingTab = ({ clientId }) => {
  const { t } = useContext(ConfigContext);

  if (!clientId) {
    return null;
  }

  return (
    <Container>
      <FlexColumn>
        <TabTitle>{t('invoicingSettings__invoicingPreference')}</TabTitle>
        <Body>{t('invoicingSettings__manageInvoicingPreference')}</Body>
      </FlexColumn>
      <ClientDetails />
      <Tax />
      <BankDetails />
      <TimeSheets />
      {/*<ShareInvoices />*/}
      <Settings />
    </Container>
  );
};
